import type { LegalDocumentType } from '@api/hooks/useProfiles';
import { Switcher } from '@components/Switcher/Switcher';
import { LEGAL_DOCUMENTS } from '@constants/legalDocuments';
import { type MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LegalDocumentPanel } from './components/LegalDocumentPanel';

interface LegalDocumentTabsProps {
	heightClassName?: string;
	types: LegalDocumentType[];
}

export const LegalDocumentTabs = ({ heightClassName, types }: LegalDocumentTabsProps) => {
	const { t } = useTranslation();
	const [activeType, setActiveType] = useState(types[0]);

	const showLinkedDocument = (event: MouseEvent<HTMLDivElement>) => {
		const link = (event.target as HTMLElement).closest('a');
		if (!link?.dataset.document) return;

		event.preventDefault();
		setActiveType(
			(current) => types.find((type) => type === link.dataset.document) ?? current,
		);
	};

	return (
		// eslint-disable-next-line jsx-a11y-x/click-events-have-key-events, jsx-a11y-x/no-static-element-interactions -- handles clicks on the document links inside
		<div className="flex flex-col gap-space-16" onClick={showLinkedDocument}>
			{types.length > 1 && (
				<Switcher
					buttonClassName="flex-1 min-w-0!"
					className="w-full"
					onChange={(type) => setActiveType(type as LegalDocumentType)}
					options={types.map((type) => ({
						label: t(LEGAL_DOCUMENTS[type].tabLabelKey),
						value: type,
					}))}
					optionsClassName="flex w-full"
					value={activeType}
				/>
			)}
			<LegalDocumentPanel
				key={activeType}
				heightClassName={heightClassName}
				type={activeType}
			/>
		</div>
	);
};
